export default "__VITE_ASSET__C3B6W9eu__"